import React from 'react';
import { UserPlusIcon, UsersIcon, AlertTriangleIcon, ClockIcon, CheckCircleIcon, FileTextIcon, CreditCardIcon } from 'lucide-react';
export function VendorDashboard({
  vendors,
  setCurrentView,
  locale = 'en-US'
}) {
  // Calculate summary statistics
  const totalVendors = vendors.length;
  const activeVendors = vendors.filter(vendor => vendor.status === 'Active').length;
  const pendingOnboarding = vendors.filter(vendor => vendor.status === 'Pending Onboarding' || vendor.status === 'Invited').length;
  // Check for bank account compliance issues
  const bankAccountIssues = vendors.filter(vendor => vendor.status === 'Active' && (!vendor.bankAccounts || vendor.bankAccounts.length === 0 || vendor.bankAccounts.some(account => !account.bankName || !account.accountNumber || !account.routingNumber))).length;
  // Update compliance issues count to include bank account issues
  const complianceIssues = vendors.filter(vendor => vendor.complianceStatus === 'Non-Compliant' || vendor.complianceStatus === 'Expired' || vendor.documents.some(doc => doc.status === 'Expired') || vendor.status === 'Active' && (!vendor.bankAccounts || vendor.bankAccounts.length === 0 || vendor.bankAccounts.some(account => !account.bankName || !account.accountNumber || !account.routingNumber))).length;
  // Get recent vendors
  const recentVendors = [...vendors].sort((a, b) => new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime()).slice(0, 5);
  // Get vendors with compliance issues, including bank account issues
  const vendorsWithIssues = vendors.filter(vendor => vendor.complianceStatus === 'Non-Compliant' || vendor.complianceStatus === 'Expired' || vendor.documents.some(doc => doc.status === 'Expired') || vendor.status === 'Active' && (!vendor.bankAccounts || vendor.bankAccounts.length === 0 || vendor.bankAccounts.some(account => !account.bankName || !account.accountNumber || !account.routingNumber))).slice(0, 5);
  return <div data-id="element-18961">
      <div className="mb-8 flex justify-between items-center" data-id="element-18962">
        <div data-id="element-18963">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-18964">
            Vendor Dashboard
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-18965">
            Overview of your vendor network and compliance status
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-18966">
          <button onClick={() => setCurrentView('onboard-vendor')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-18967">
            <UserPlusIcon className="h-4 w-4 mr-1" data-id="element-18968" />
            Add New Vendor
          </button>
          <button onClick={() => setCurrentView('vendors')} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-18969">
            <UsersIcon className="h-4 w-4 mr-1" data-id="element-18970" />
            View All Vendors
          </button>
        </div>
      </div>
      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8" data-id="element-18971">
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-18972">
          <div className="p-5" data-id="element-18973">
            <div className="flex items-center" data-id="element-18974">
              <div className="flex-shrink-0" data-id="element-18975">
                <UsersIcon className="h-6 w-6 text-gray-400" data-id="element-18976" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-18977">
                <dl data-id="element-18978">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-18979">
                    Total Vendors
                  </dt>
                  <dd data-id="element-18980">
                    <div className="text-lg font-medium text-gray-900" data-id="element-18981">
                      {totalVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-18982">
          <div className="p-5" data-id="element-18983">
            <div className="flex items-center" data-id="element-18984">
              <div className="flex-shrink-0" data-id="element-18985">
                <CheckCircleIcon className="h-6 w-6 text-green-400" data-id="element-18986" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-18987">
                <dl data-id="element-18988">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-18989">
                    Active Vendors
                  </dt>
                  <dd data-id="element-18990">
                    <div className="text-lg font-medium text-gray-900" data-id="element-18991">
                      {activeVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-18992">
          <div className="p-5" data-id="element-18993">
            <div className="flex items-center" data-id="element-18994">
              <div className="flex-shrink-0" data-id="element-18995">
                <ClockIcon className="h-6 w-6 text-blue-400" data-id="element-18996" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-18997">
                <dl data-id="element-18998">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-18999">
                    Pending Onboarding
                  </dt>
                  <dd data-id="element-19000">
                    <div className="text-lg font-medium text-gray-900" data-id="element-19001">
                      {pendingOnboarding}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-19002">
          <div className="p-5" data-id="element-19003">
            <div className="flex items-center" data-id="element-19004">
              <div className="flex-shrink-0" data-id="element-19005">
                <AlertTriangleIcon className="h-6 w-6 text-yellow-400" data-id="element-19006" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-19007">
                <dl data-id="element-19008">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-19009">
                    Compliance Issues
                  </dt>
                  <dd data-id="element-19010">
                    <div className="text-lg font-medium text-gray-900" data-id="element-19011">
                      {complianceIssues}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Recent Vendors and Compliance Issues */}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-19012">
        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-19013">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-19014">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-19015">
              Recently Updated Vendors
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-19016">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-19017">
            {recentVendors.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-19018">
                No vendors found.
              </li> : recentVendors.map(vendor => <li key={vendor.id} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendor-details')} data-id="element-19019">
                  <div className="flex items-center justify-between" data-id="element-19020">
                    <div className="flex items-center" data-id="element-19021">
                      <div className="flex-shrink-0" data-id="element-19022">
                        <UsersIcon className="h-5 w-5 text-gray-400" data-id="element-19023" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-19024">
                        {vendor.name}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-19025">
                      {getStatusBadge(vendor.status)}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-19026">
                    <div className="sm:flex" data-id="element-19027">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-19028">
                        {vendor.type} • {vendor.country}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-19029">
                      <p data-id="element-19030">
                        Last updated:{' '}
                        <span className="ml-1.5" data-id="element-19031">{vendor.lastUpdated}</span>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>
        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-19032">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-19033">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-19034">
              Compliance Issues
            </h3>
            <button onClick={() => setCurrentView('compliance-check')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-19035">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-19036">
            {vendorsWithIssues.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-19037">
                No compliance issues found.
              </li> : vendorsWithIssues.map(vendor => <li key={vendor.id} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('compliance-check')} data-id="element-19038">
                  <div className="flex items-center justify-between" data-id="element-19039">
                    <div className="flex items-center" data-id="element-19040">
                      <div className="flex-shrink-0" data-id="element-19041">
                        {hasBankAccountIssue(vendor) ? <CreditCardIcon className="h-5 w-5 text-orange-400" data-id="element-19042" /> : <AlertTriangleIcon className="h-5 w-5 text-yellow-400" data-id="element-19043" />}
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-19044">
                        {vendor.name}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-19045">
                      {getComplianceBadge(vendor.complianceStatus)}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-19046">
                    <div className="sm:flex" data-id="element-19047">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-19048">
                        {getComplianceIssue(vendor)}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-19049">
                      <p data-id="element-19050">
                        <button className="text-indigo-600 hover:text-indigo-900" onClick={e => {
                    e.stopPropagation();
                    setCurrentView('compliance-check');
                  }} data-id="element-19051">
                          Review
                        </button>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>
      </div>
      {/* Upcoming Tasks */}
      <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-19052">
        <div className="px-4 py-5 border-b border-gray-200 sm:px-6" data-id="element-19053">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-19054">
            Upcoming Tasks
          </h3>
        </div>
        <ul className="divide-y divide-gray-200" data-id="element-19055">
          <li className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-19056">
            <div className="flex items-center justify-between" data-id="element-19057">
              <div className="flex items-center" data-id="element-19058">
                <div className="flex-shrink-0" data-id="element-19059">
                  <FileTextIcon className="h-5 w-5 text-gray-400" data-id="element-19060" />
                </div>
                <p className="ml-2 text-sm font-medium text-gray-900" data-id="element-19061">
                  Dell Technologies - Insurance Certificate Renewal
                </p>
              </div>
              <div className="ml-2 flex-shrink-0" data-id="element-19062">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-19063">
                  Due in 5 days
                </span>
              </div>
            </div>
          </li>
          <li className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-19064">
            <div className="flex items-center justify-between" data-id="element-19065">
              <div className="flex items-center" data-id="element-19066">
                <div className="flex-shrink-0" data-id="element-19067">
                  <ClockIcon className="h-5 w-5 text-gray-400" data-id="element-19068" />
                </div>
                <p className="ml-2 text-sm font-medium text-gray-900" data-id="element-19069">
                  PrintWorks Inc. - Complete Onboarding
                </p>
              </div>
              <div className="ml-2 flex-shrink-0" data-id="element-19070">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-19071">
                  Pending
                </span>
              </div>
            </div>
          </li>
          <li className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-19072">
            <div className="flex items-center justify-between" data-id="element-19073">
              <div className="flex items-center" data-id="element-19074">
                <div className="flex-shrink-0" data-id="element-19075">
                  <UsersIcon className="h-5 w-5 text-gray-400" data-id="element-19076" />
                </div>
                <p className="ml-2 text-sm font-medium text-gray-900" data-id="element-19077">
                  Office Depot - Semi-annual Review
                </p>
              </div>
              <div className="ml-2 flex-shrink-0" data-id="element-19078">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-19079">
                  Due in 30 days
                </span>
              </div>
            </div>
          </li>
          <li className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-19080">
            <div className="flex items-center justify-between" data-id="element-19081">
              <div className="flex items-center" data-id="element-19082">
                <div className="flex-shrink-0" data-id="element-19083">
                  <CreditCardIcon className="h-5 w-5 text-gray-400" data-id="element-19084" />
                </div>
                <p className="ml-2 text-sm font-medium text-gray-900" data-id="element-19085">
                  Global Logistics Partners - Update Banking Details
                </p>
              </div>
              <div className="ml-2 flex-shrink-0" data-id="element-19086">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-19087">
                  Urgent
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>;
}
// Helper function to render status badges
function getStatusBadge(status) {
  switch (status) {
    case 'Active':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-19088">
          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-19089" />
          {status}
        </span>;
    case 'Pending Onboarding':
    case 'Invited':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-19090">
          <ClockIcon className="mr-1 h-3 w-3" data-id="element-19091" />
          {status}
        </span>;
    case 'Inactive':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-19092">
          <UsersIcon className="mr-1 h-3 w-3" data-id="element-19093" />
          {status}
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-19094">
          {status}
        </span>;
  }
}
function getComplianceBadge(status) {
  switch (status) {
    case 'Compliant':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-19095">
          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-19096" />
          {status}
        </span>;
    case 'Pending Review':
    case 'Incomplete':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-19097">
          <ClockIcon className="mr-1 h-3 w-3" data-id="element-19098" />
          {status}
        </span>;
    case 'Non-Compliant':
    case 'Expired':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-19099">
          <AlertTriangleIcon className="mr-1 h-3 w-3" data-id="element-19100" />
          {status}
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-19101">
          {status}
        </span>;
  }
}
// Helper function to check if a vendor has bank account issues
function hasBankAccountIssue(vendor) {
  return vendor.status === 'Active' && (!vendor.bankAccounts || vendor.bankAccounts.length === 0 || vendor.bankAccounts.some(account => !account.bankName || !account.accountNumber || !account.routingNumber));
}
function getComplianceIssue(vendor) {
  // Check for bank account issues first
  if (hasBankAccountIssue(vendor)) {
    if (!vendor.bankAccounts || vendor.bankAccounts.length === 0) {
      return 'Missing bank account information';
    } else {
      return 'Incomplete bank account details';
    }
  }
  // Then check for other compliance issues
  if (vendor.complianceStatus === 'Expired' || vendor.complianceStatus === 'Non-Compliant') {
    return `Compliance status: ${vendor.complianceStatus}`;
  }
  const expiredDocs = vendor.documents.filter(doc => doc.status === 'Expired');
  if (expiredDocs.length > 0) {
    return `${expiredDocs.length} expired document${expiredDocs.length > 1 ? 's' : ''}`;
  }
  return 'Compliance issue detected';
}